/**
 * Maps the current route to its ProductFruits tour id, so the header's
 * "replay walkthrough" menu can start the right tour instead of one built
 * for a different page's elements. sp-lite and servicepoints.nl are separate
 * ProductFruits workspaces with their own tours for the same routes, so the
 * lookup is keyed by brand (getSSOProvider()) first, then by route. Add an
 * entry under the matching brand's routeTours in productFruitsTours.json
 * whenever a new page-specific tour is published for that brand.
 */
import tourConfig from "../constants/productFruitsTours.json";
import { getSSOProvider } from "./ssoProvider.js";

const PLACEHOLDER_PREFIX = "REPLACE_WITH_";

const isConfigured = tourId => Boolean(tourId) && !tourId.startsWith(PLACEHOLDER_PREFIX);

const getBrandTourConfig = () => tourConfig[getSSOProvider()];

export const getTourIdForPath = pathname => {
  const brandConfig = getBrandTourConfig();
  const match = brandConfig?.routeTours.find(entry => pathname?.includes(entry.routeMatch));
  return isConfigured(match?.tourId) ? match.tourId : null;
};

// "App walkthrough": a standalone copy of the dashboard's first-login tour,
// published separately with no chained follow-up tour and a "Manually"
// trigger, so replaying it from any page never re-triggers that chain.
export const getGlobalWalkthroughTourId = () => {
  const brandConfig = getBrandTourConfig();
  return isConfigured(brandConfig?.globalWalkthroughTourId) ? brandConfig.globalWalkthroughTourId : null;
};

// tryStartTour resets the user's state for this tour to "not_finished" and
// starts it, which is what re-runs a tour ProductFruits already recorded as
// seen (tours are set to trigger "Once per user"). Calling it for a tour
// whose target elements aren't on the current page causes ProductFruits to
// navigate there itself (via window.location.href by default), so only ever
// call this with the tour id for the page the user is currently on.
export const replayTour = tourId => {
  if (!tourId || !window.productFruits?.api?.tours?.tryStartTour) return false;
  try {
    window.productFruits.api.tours.tryStartTour(tourId);
    return true;
  } catch (_) {
    return false;
  }
};
